<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import DokkanCharacterList from "@/components/DokkanCharacterList.vue";
import { Character } from "@/types/character";

const props = defineProps<{
  characters: Character[];
}>();
</script>

<template>
  <BaseCard>
    <template #heading>F2P Super Attack Fodder</template>

    <DokkanCharacterList :characters="characters" :scale="0.69" />
  </BaseCard>
</template>

<style scoped></style>
